import ApiHelper from "../../helpers/ApiHelper";
import GeneralHelper from "../../helpers/GeneralHelper";
import BaseService from "../BaseService";

class ServiceCenterService extends BaseService {

    static url = "service-centers";
    static apis = {
        that: this,
        get: function() {
            return this.that.url;
        },

        findById: function(id) {
            return this.that.url + '/find/' + id;
        },

        edit: function() {
            return this.that.url;
        },

        create: function() {
            return this.that.url;
        },

        delete: function(data) {
            return this.that.url;
        },

        findByCustomerId: function() {
            return this.that.url + '/by-customer';
        },
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("service-centers");
    }

    
    delete(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: ServiceCenterService.apis.delete(),
                    method: "DELETE",
                    data: data,
                    showLoader: true,
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

 

    get() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: ServiceCenterService.apis.get(),
                    method: "GET",
                    showLoader: true,
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getBasedOnCategory(category_id, specs) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: ServiceCenterService.apis.get()+'/'+category_id+`?specs=${JSON.stringify(specs)}`,
                    method: "GET",
                    showLoader: true,
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }


    findById(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: ServiceCenterService.apis.findById(id),
                    method: "GET",
                    showLoader: true,
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    fintByCustomerId() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: ServiceCenterService.apis.findByCustomerId(),
                    method: "GET",
                    showLoader: true,
                    authorization: true,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }


    edit(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: ServiceCenterService.apis.edit(),
                    method: "PUT",
                    data: data,
                    showLoader: true,
                    authorization: true,
                    message: {
                        success: GeneralHelper.buildMessage(1, "Successfully updated!")
                    }
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    create(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: ServiceCenterService.apis.create(),
                    method: "POST",
                    data: data,
                    showLoader: true,
                    authorization: true,
                    message: {
                        success: GeneralHelper.buildMessage(1, "Successfully created!")
                    }
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

  
}

export default ServiceCenterService;